import WallFactory from './wall-factory';
import AreaFactory from './area-factory';

export {
  WallFactory,
  AreaFactory
};

export default {
  WallFactory,
  AreaFactory
};
